module.exports = __webpack_public_path__ + "static/media/f.94dd287f.m4a";